let dash = null;

const _consoleError = console.error;
console.error = (...args) => {
  if (typeof args[0] === 'string' && (args[0].includes('[CmcdController]') || args[0].includes('[CapabilitiesFilter]'))) return;
  _consoleError(...args);
};

export async function dashjs() {
  if (dash == null) {
    dash = await import('dashjs');
  }

  return dash;
}
